import React, { useState } from "react";
import { FaBell } from "react-icons/fa";
import "./Announcements.css";

const Announcements = () => {
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);
  const [readAnnouncements, setReadAnnouncements] = useState([]);

  const announcements = [
    {
      id: 1,
      title: "Upcoming Member Meeting",
      date: "Sun, Mar 10, 2024",
      content:
        "Join us for our monthly member meeting on Saturday, March 16th at 2:00 PM. We'll be discussing important policy updates and upcoming initiatives.",
    },
    {
      id: 2,
      title: "Volunteer Recognition Event",
      date: "Mon, Mar 18, 2024",
      content:
        "Celebrate our dedicated volunteers on Monday, March 18th at 4:00 PM. Refreshments will be served, and awards will be presented to outstanding members.",
    },
    {
      id: 3,
      title: "Community Cleanup",
      date: "Fri, Mar 22, 2024",
      content:
        "Join us for a community cleanup drive at the central park. Gloves, bags, and refreshments will be provided. Let's make our environment cleaner together.",
    },
    {
      id: 4,
      title: "Fundraising Gala",
      date: "Sat, Apr 6, 2024",
      content:
        "Our annual fundraising gala will be held at the Grand Hall. Expect dinner, entertainment, and an inspiring keynote address.",
    },
    {
      id: 5,
      title: "Training Workshop",
      date: "Wed, Apr 10, 2024",
      content:
        "A professional development workshop will be hosted for all members on leadership and effective collaboration.",
    },
    {
      id: 6,
      title: "Board Elections",
      date: "Sun, Apr 14, 2024",
      content:
        "Elections for new board members will be conducted. Your participation is crucial to ensure fair representation.",
    },
    {
      id: 7,
      title: "Charity Walk",
      date: "Sat, Apr 20, 2024",
      content:
        "Support our charity walk for education. Meeting point is at City Stadium, 8:00 AM sharp. Bring comfortable shoes!",
    },
    {
      id: 8,
      title: "Youth Forum",
      date: "Thu, Apr 25, 2024",
      content:
        "Interactive youth forum to discuss community issues, brainstorm solutions, and network with peers.",
    },
    {
      id: 9,
      title: "Technology Fair",
      date: "Tue, Apr 30, 2024",
      content:
        "Explore innovations at our technology fair showcasing young inventors and entrepreneurs.",
    },
    {
      id: 10,
      title: "Annual General Meeting",
      date: "Fri, May 3, 2024",
      content:
        "Important AGM to review yearly progress, financial reports, and set future plans.",
    },
  ];

  const handleOpen = (announcement) => {
    setSelectedAnnouncement(announcement);
    if (!readAnnouncements.includes(announcement.id)) {
      setReadAnnouncements([...readAnnouncements, announcement.id]);
    }
  };

  const handleClose = () => {
    setSelectedAnnouncement(null);
  };

  return (
    <div className="announcements-page">
      {/* Header */}
      <div className="announcements-header">
        <FaBell className="bell-icon" />
        <h2>Announcements</h2>
      </div>

      {/* List */}
      <div className="announcement-container">
        {announcements.map((a) => (
          <div
            key={a.id}
            className={`announcement-card ${
              readAnnouncements.includes(a.id) ? "read" : "unread"
            }`}
            onClick={() => handleOpen(a)}
          >
            <h4>
              {a.title} <span className="dot">•</span>
            </h4>
            <p className="date">{a.date}</p>
            <p className="message-preview">{a.content}</p>
            {!readAnnouncements.includes(a.id) ? (
              <p className="mark-blur">Mark As Read</p>
            ) : (
              <p className="mark-blur done">Already Read</p>
            )}
          </div>
        ))}
      </div>

      {/* Modal */}
      {selectedAnnouncement && (
        <div className="modal-overlay" onClick={handleClose}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>{selectedAnnouncement.title}</h3>
            <p className="date">{selectedAnnouncement.date}</p>
            <p className="modal-text">{selectedAnnouncement.content}</p>
            <button className="close-btn" onClick={handleClose}>
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Announcements;
